import { Component, OnDestroy, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, TemplateRef, NgZone, Output, EventEmitter } from "@angular/core";
import { ViewportRuler } from '@angular/cdk/scrolling';
import { Observable, Subscription, Observer } from "rxjs";
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SecurityService, LoaderService, PortalService, CoreService,AuthorizationService } from "src/app/services";
import { environment } from "src/environments/environment";
import { IPortalNavigation, PlatForm, IPortalConfig, Tools } from 'src/app/models';
import $ from 'jquery';
import { NgbOffcanvas, NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap'; /*, NgbActiveModal, NgbModal*/
import { Helpers } from "src/app/helpers";
import _ from "lodash";
import { NavigatesearchService } from "src/app/services/navigatesearch.service";
import { FormControl, FormGroup } from "@angular/forms";
import { OrderByPipe } from 'ngx-pipes';
import { Constants } from "src/app/shared/models/constants";
@Component({
    selector: 'medpt-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [OrderByPipe],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  searchText: string = "";
  myGroup = new FormGroup({
    searchText: new FormControl()
  });
  dropdownOpened = false;
  @ViewChild('dropdown', { static: false }) protected dropdown!: ElementRef;
  listenFunc!: Function;
  @Output() claerSearch = new EventEmitter<any>();
  //time = new Observable<string>((observer: Observer<string>) => {
  //  setInterval(() => observer.next(new Date().toString()), 1000);
  //});
  secureAppUrl = environment.SSO.secureAppUrl;
  myAppUrl =  environment.myAppUrl;
  AdminAppUrl = Helpers.getAdminAppUrl();
  AppUrl = Helpers.getApplicationUrl();
  HeaderBrandingIconPath = Helpers.getPlatformLogo();
  cdnEndPoint = environment.cdnEndPoint;
  isPortalNavVisibled: Observable<boolean> = new Observable((ob: Observer<boolean>) => { ob.next(false); });
  isPortalSearchVisibled: Observable<boolean> = new Observable((ob: Observer<boolean>) => { ob.next(false); });
  isPortalToolVisibled: Observable<boolean> = new Observable((ob: Observer<boolean>) => { ob.next(false); });
  isUserLogged = false;
  portalDisplayName: Observable<string> = new Observable((ob: Observer<string>) => { ob.next(''); });
  toolsMenu: Observable<Array<Tools>> = new Observable((ob: Observer<Array<Tools>>) => { ob.next([]); });
  navigationMenu: Observable<Array<any>> = new Observable((ob: Observer<Array<any>>) => { ob.next([]); });
  mobileNavigationMenu: Observable<Array<any>> = new Observable((ob: Observer<Array<any>>) => { ob.next([]); });
  portalConfig: Observable<IPortalConfig> = new Observable((ob: Observer<IPortalConfig>) => { ob.next({}); });
  portalLogo: Observable<string> = new Observable((ob: Observer<string>) => { ob.next(""); });
  portalNameSubscription: Subscription;
  showPortalSectionSubscription: Subscription;
  showPortalSearchSubscription: Subscription;
  toolsMenuSubscription: Subscription;
  navigationMenuSubscription: Subscription;
  portalConfigSubscription: Subscription;
  routerSubscription: Subscription;
  isAIEnabled: boolean = false;

  portallistopened: boolean = false;
  filteredPortalList: Array<IPortalConfig> = [];
  portalList: Array<IPortalConfig> = [];
  portalName = "";
  sponsorName = "";
  IsMobileMode: boolean = false;
  $searchElm: any;
  IsDashbord: boolean = false;
  isStudyStat: boolean = (Helpers.getPlatformId() == PlatForm.StudyStat);
  isRaspberryAI: boolean = (Helpers.getPlatformId() == PlatForm.RaspberryAI);

  private readonly viewportChange = this.viewportRuler.change(200).subscribe(() => this.ngZone.run(() => this.onScreenResize()));
  constructor(
    private securityService: SecurityService,
    public portalService: PortalService,
    public activatedRouter: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private offcanvasService: NgbOffcanvas,
    private readonly viewportRuler: ViewportRuler,
    private readonly ngZone: NgZone,
    private navigatesearchService: NavigatesearchService,
    private coreService: CoreService,
    private authorizationService: AuthorizationService
  ) {

    this.routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.IsDashbord = this.router.url.toLowerCase() == '/dashboard';
      }
    });
    this.portalNameSubscription = this.portalService
      .getPortalDisplayName()
      .subscribe((title: string) => {       
        this.portalDisplayName = new Observable((ob: Observer<string>) => { ob.next(title); });
      });

    this.showPortalSectionSubscription = this.portalService
      .getShowPortalSection()
      .subscribe((showPortalSection: boolean) => {
        this.isPortalNavVisibled = new Observable((ob: Observer<boolean>) => { ob.next(showPortalSection); });
      });
     
     
      this.showPortalSearchSubscription = this.portalService
        .getShowPortalSearch()
        .subscribe((showPortalSearch: boolean) => {
          this.isPortalSearchVisibled = new Observable((ob: Observer<boolean>) => { ob.next(showPortalSearch); });
          if(Helpers.getPlatformId() == PlatForm.StudyStat || Helpers.getPlatformId() == PlatForm.RaspberryAI){
            this.isPortalSearchVisibled = new Observable((ob: Observer<boolean>) => { ob.next(false); });
          }
        });
    

    this.toolsMenuSubscription = this.portalService
      .getToolsMenuSubject()
      .subscribe((toolsMenu: Array<Tools>) => {

        toolsMenu.forEach((item, index) => {
          item.AdminToolSubMenu = _.orderBy(item.AdminToolSubMenu, ['SubMenuDisplayName'], ['asc']);
          item.AdminToolSubMenu.forEach((subitem, subindex) => {
            if (subitem.SubMenuUrl.charAt(0) != "/") {
              subitem.SubMenuUrl = "/" + subitem.SubMenuUrl;
            }
          });
        });

        let isPortalToolVisibled = false;
        if (toolsMenu.length == 2)
          isPortalToolVisibled = toolsMenu[0].AdminToolSubMenu.length > 0 || toolsMenu[1].AdminToolSubMenu.length > 0
        else if (toolsMenu.length == 1)
          isPortalToolVisibled = toolsMenu[0].AdminToolSubMenu.length > 0;

        this.isPortalToolVisibled = new Observable((ob: Observer<boolean>) => { ob.next(isPortalToolVisibled); });
        if (isPortalToolVisibled)
          this.toolsMenu = new Observable((ob: Observer<Array<Tools>>) => { ob.next(toolsMenu); });
      });

    this.navigationMenuSubscription = this.portalService
      .getNavigationMenuSubject()
      .subscribe((navigation: IPortalNavigation[]) => {
        
        this.navigationMenu = new Observable((ob: Observer<Array<IPortalNavigation>>) => { ob.next(navigation); });
        
        var mobileNavigation = _.cloneDeep(navigation);
        if(Helpers.getPlatformId() == PlatForm.StudyStat){
          mobileNavigation = _.filter(mobileNavigation, (nav) => { return nav.FeatureName == 'Forms' || nav.FeatureName == 'SafetyReports' || nav.FeatureName == 'CloudPortDocuments' || nav.FeatureName == 'Menu' || nav.FeatureName == 'StudyResources' ||nav.FeatureName == 'StudyMetrics' ||  nav.ChildFeatures.length > 0; });
        }else if(Helpers.getPlatformId() == PlatForm.RaspberryAI){
           mobileNavigation = _.filter(mobileNavigation, (nav) => { return nav.FeatureName == 'Forms' || nav.FeatureName == 'SafetyReports' || nav.FeatureName == 'CloudPortDocuments' || nav.FeatureName == 'Menu' || nav.FeatureName == 'RASPberryAI' || nav.FeatureName == 'RAIMetrics' ||  nav.ChildFeatures.length > 0;  });
        }else{
           mobileNavigation = _.filter(mobileNavigation, (nav) => { return nav.FeatureName == 'Forms' || nav.FeatureName == 'SafetyReports' || nav.FeatureName == 'CloudPortDocuments' || nav.FeatureName == 'Menu' || nav.ChildFeatures.length > 0;  });
        }
        this.mobileNavigationMenu = new Observable((ob: Observer<Array<IPortalNavigation>>) => { ob.next(mobileNavigation); });
      });

    this.portalConfigSubscription = this.portalService
      .getPortalConfigSubject()
      .subscribe((config: IPortalConfig) => {
        this.portalConfig = new Observable((ob: Observer<IPortalConfig>) => { ob.next(config); });
        
        this.portalName = config.PortalName!;
        this.sponsorName = config.SponsorName!;
        if(config.IsStartupEnabled){
          this.HeaderBrandingIconPath = environment.cdnEndPoint + "/medpointapps/img/AppLogos/TriPort_Startup_color.svg";
        }
        else{
          this.HeaderBrandingIconPath = Helpers.getPlatformLogo();
        }
        
        if (config.ClientLogo != "") {
          $.get(this.cdnEndPoint + '/' + config.ClientLogo).then((data) => {
            this.portalLogo = new Observable((ob: Observer<string>) => { ob.next(this.cdnEndPoint + '/' + config.ClientLogo); });
          }, (err) => {
            this.portalLogo = new Observable((ob: Observer<string>) => { ob.next(""); });
          });
        }
      });

      this.portalService.getAllFeaturesSubject().subscribe(features=>{
        this.isAIEnabled = (this.authorizationService.isNavigationOrFeatueAllowed(Constants.RASPberryAI_CHATBOT_FEATURE_NAME) && Helpers.getPlatformId() != PlatForm.RaspberryAI);
      });

    this.coreService.getUserPortals()
      .then((portals: Array<IPortalConfig>) => {
        //portals = _.filter(portals, { Portals: [{ PortalID: portalId }] });
        //this.portalList = this.filteredPortalList = portals.length > 0 ? (portals[0].Portals == null || portals[0].Portals == undefined) ? [] : portals[0].Portals : [];
        _.each(portals, (item: IPortalConfig, index: number) => {
          _.each(item.Portals, (childitem: IPortalConfig, childindex: number) => {
            this.portalList.push(childitem);
          });
        });
        this.portalList = _.orderBy(this.portalList, ['DisplayName'], ['asc']);
        this.filteredPortalList = this.portalList;

      }).catch((error: any) => {

      }).finally(() => {

      });

  }
  resetMobileMenu(open: boolean, navDrop: NgbDropdown) {
    if (!open) {
      this.mobileNavigationMenu.forEach((arrayitem: Array<any>) => {
        arrayitem.forEach((item: any) => {
          item.opened = false;
        });
      });

      this.toolsMenu.forEach((arrayitem: Array<Tools>) => {
        arrayitem.forEach((item: Tools) => {
          item.opened = false;
        });
      });
    }
  }

  applyFilter($event: any) {
    this.filteredPortalList = this.portalList.filter((item: any) => {
      if (item.DisplayName.toString().toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    });
  }

  onPortalSearch($event: any) {
    //$('.dropdown-menu.finduser-wrap').hide();
    $(".dropdown-menu.finduser-wrap").show();
    if (this.myGroup.controls['searchText'].value != undefined && this.myGroup.controls['searchText'].value != null && this.myGroup.controls['searchText'].value != '') {
      this.navigatesearchService.setSearchString(this.myGroup.controls['searchText'].value);
      this.router.navigate(["Search"], { relativeTo: this.activatedRouter, queryParams: { q: this.myGroup.controls['searchText'].value } }); //$event.target.value

    }
    else {
      this.navigatesearchService.setSearchString('');
    }
  }

  openSearchWindow(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'top', panelClass: 'search-canvas', scroll: true });
  }

  ngAfterViewInit() {
    // $('#topmenu-search a').mouseenter(function (e) {
    //   var $searchElm = $(this);
    //   if ($searchElm.parent().find(".dropdown-menu").css("display") == 'none') {
    //     $searchElm.parent().find(".dropdown-menu").show();
    //     $searchElm.parent().find(".dropdown-menu input").val('');
    //     setTimeout(function () {
    //       $searchElm.parent().find(".dropdown-menu input").val('').focus();
    //     }, 500);
    //   }
    //   e.preventDefault();
    // });
    $('.finduser-wrap .form-control-wrap').mouseleave(function (e) {
      if ($(this).find("input").val() == "") {
        $(this).parent().hide();
      }
      e.preventDefault();
    });
  }

  over(drop: NgbDropdown) {
    drop.open()
  }

  out(drop: NgbDropdown) {
    drop.close()
  }

  logout() {
    this.loaderService.showLoader();
    setTimeout(() => { this.securityService.logout(); });
  }



  getToolImageSource(type: string) {
    let imageSrc = this.cdnEndPoint;
    switch (type) {
      case 'search':
        imageSrc = imageSrc + '/triport/icons/community/search.svg';
        break;
      case 'admin':
        imageSrc = imageSrc + '/triport/icons/topmenu/admin.svg';
        break;
      case 'notification':
        imageSrc = imageSrc + '/triport/icons/topmenu/notification.svg';
        break;
      case 'help':
        imageSrc = imageSrc + '/triport/icons/topmenu/help.svg';
        break;
      case 'user':
        imageSrc = imageSrc + '/triport/icons/topmenu/user.svg';
        break;
      case 'apps':
        imageSrc = imageSrc + '/triport/icons/leftmenu/apps.svg';
        break;
    }
    return imageSrc
  }

  goToPath(path: string) {
    return this.router.navigate([path], { relativeTo: this.activatedRouter });
  }

  ngOnInit() {
    const currentUser = this.securityService.currentUserValue;
    if (currentUser) {
      this.isUserLogged = true;
    }
    this.onScreenResize();
  }

  ngOnDestroy() {
    if (this.portalNameSubscription != undefined)
      this.portalNameSubscription.unsubscribe();

    if (this.showPortalSectionSubscription != undefined)
      this.showPortalSectionSubscription.unsubscribe();

    if (this.showPortalSearchSubscription != undefined)
      this.showPortalSearchSubscription.unsubscribe();

    if (this.toolsMenuSubscription != undefined)
      this.toolsMenuSubscription.unsubscribe();

    if (this.navigationMenuSubscription != undefined)
      this.navigationMenuSubscription.unsubscribe();

    if (this.portalConfigSubscription != undefined)
      this.portalConfigSubscription.unsubscribe();

    if (this.routerSubscription != undefined)
      this.routerSubscription.unsubscribe();
  }

  onScreenResize() {
    const { width, height } = this.viewportRuler.getViewportSize();
    if (width > 900)
      this.IsMobileMode = false;
    else
      this.IsMobileMode = true;
  }
 
}
